
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "./useAuth";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ element: Component, requiredRole, ...rest }) => {
    const { user, loading, error } = useAuth();
    const location = useLocation(); // Captura a rota atual
    const { products } = useSelector((state) => state.cart);
    const isCheckoutCompleted = sessionStorage.getItem('checkout_completed') === 'true';
    if (products.length === 0 && !isCheckoutCompleted) {
        return <Navigate to="/carrinho" replace />;
    }
    if (loading) return <div>Loading...</div>; // Você pode substituir por um componente de carregamento
    if (error) return <Navigate to="/login-checkout" state={{ from: location }} />; // Redireciona para login se houver erro

    if (user && (!requiredRole || user.profile === requiredRole)) {
        return <Component {...rest} />; // Renderiza o componente se o usuário estiver autenticado e autorizado
    }

    // ✅ Verifica se o carrinho está vazio

    return <Navigate to="/login-checkout" state={{ from: location }} replace />;
};

export default ProtectedRoute;
